import { borderRadius } from '@design-system/tokens';
import { useState, useEffect, useCallback } from 'react';

interface PreviewFrameProps {
  playbackId: string;
  time: number;
  customThumbnailUrl?: string | null;
  height?: number;
  className?: string;
}

const DEFAULT_DEBOUNCE_MS = 300;
const DEFAULT_HEIGHT = 348;
const DEFAULT_BORDER_RADIUS = '6px';

const generateMuxThumbnailUrl = (playbackId: string, time: number): string =>
  `https://image.mux.com/${playbackId}/thumbnail.webp?time=${time}`;

const useDebounced = <T,>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

export function PreviewFrame({
  playbackId,
  time,
  customThumbnailUrl,
  height = DEFAULT_HEIGHT,
  className = '',
}: PreviewFrameProps) {
  const debouncedTime = useDebounced(time, DEFAULT_DEBOUNCE_MS);

  const thumbnailUrl =
    customThumbnailUrl || generateMuxThumbnailUrl(playbackId, debouncedTime);
  return (
    <div className={`flex justify-center bg-black ${className}`}>
      <img
        src={thumbnailUrl}
        alt="Video thumbnail preview"
        style={{
          height,
          borderRadius: DEFAULT_BORDER_RADIUS,
        }}
      />
    </div>
  );
}
